export const TEST_ACTION = "TEST_ACTION";
export const ADD_NUMBER = "ADD_NUMBER";
export const RESET_NUMBER = "RESET_NUMBER";
export const PATCH_UPLOAD_STATUS = "PATCH_UPLOAD_STATUS";
export const RESET_ZOOM = "RESET_ZOOM";
export const PERMISSIONS = "PERMISSIONS";
export const USER_LOADING = "USER_LOADING";
export const USER_SUCCESS = "USER_SUCCESS";
export const USER_FAIL = "USER_FAIL";
export const CONFIGURABLE_DATA = "CONFIGURABLE_DATA";
export const THEME_STATE = "THEME_STATE";
